import { useRef } from 'react';
import { interval, from, timer, concatMap } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { fetchSyncDataForSpace } from '../../../../../api/calendarSync';
import useCalendarStore from '../../store/calendar/useCalendarStore';
import { SyncStatus } from '../util/syncStatus';

const intervalMs = 2_000;
const timeoutMs = 180_000;

const useCalendarSyncPolling = (onSyncComplete) => {
  const spaceId = useCalendarStore(state => state.selectedSpaceId);
  const setSyncedCalendarData = useCalendarStore(state => state.setSyncedCalendarData);
  const setSyncStatus = useCalendarStore(state => state.setSyncStatus);

  const subscriptionRef = useRef(null);

  const stop = () => {
    subscriptionRef.current?.unsubscribe?.();
    subscriptionRef.current = null;
  };

  const start = () => {
    stop();

    if (!spaceId) {
      return;
    }

    const timeout$ = timer(timeoutMs);

    subscriptionRef.current = interval(intervalMs)
      .pipe(
        takeUntil(timeout$),
        concatMap(() => from(fetchSyncDataForSpace(spaceId)))
      )
      .subscribe((response) => {
        const { data, error } = response;
        if (!data || error) {
          stop();
          return;
        }

        const { obj_state: status = '', ...syncedCalendarData } = data;

        if (!status || status === SyncStatus.SYNCING) return;

        setSyncStatus(status);
        setSyncedCalendarData(syncedCalendarData);

        // This should be removed in the future and all side effects should be handled within this one subscription
        onSyncComplete?.();
        stop();
      });
  };

  return {
    startCalendarSyncPolling: start,
    stopCalendarSyncPolling: stop
  };
};

export default useCalendarSyncPolling;
